import React from "react";
import "./featuredPosts.scss";
import PostCardHorizontal from "../postCard/postCardHorizontal";

const FeaturedPosts = ({ posts }) => {
  return (
    <>
      <div className="featured-posts">
        <div className="featured-title">Featured</div>
        <ul className="featured-list-wrap">
          {posts.slice(0, 4).map(post => {
            return (
              <li
                key={post.uri}
                className="featured-list-item"
              >
                <PostCardHorizontal post={post} />
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default FeaturedPosts;
